import {
  GET_ALL_SERVICE,
  GET_SERVICE
} from 'src/store/mutation-types'
export default {
  [GET_ALL_SERVICE]: (state, services) => {
    state.services = services
  },
  [GET_SERVICE]: (state, service) => {
    state.service = service
  }
}



// WEBPACK FOOTER //
// ./src/components/service/store/mutations.js